<div
  class="controller-head-outline"
  [ngClass]="{'controller-head-outline__active': isHeadOutlineShown()}"
  (click)="toggleHeadOutline()"
>
  <div class="controller-head-outline__icon">
    <img
      class="controller-head-outline__icon-image"
      ngSrc="/assets/images/icons/view-type.svg"
      width="24"
      height="24"
      alt="Head Outline Icon"
    >
  </div>

  <div class="controller-head-outline__label">Head Outline</div>
</div>
